import { Cancel, MoreVert, Search, Tune } from "@material-ui/icons";
import moment from "moment";
import { default as React } from "react";
import {
  Button,
  Card,
  Carousel,
  Col,
  Dropdown,
  Form,
  InputGroup,
  Row,
  Modal,
} from "react-bootstrap";
import { buildStyles, CircularProgressbar } from "react-circular-progressbar";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import ImageLoader from "react-load-image";
import { connect } from "react-redux";
import {
  deleteTransactionDataAction,
  getAllTransactionsAction,
  getAllTransactionsActionWithPagination,
} from "../../../actions/TransactionActions";
import { getTransactionTypeAction } from "../../../actions/TransactionTypeActions";
import { getVendorTransactionsAction } from "../../../actions/VendorTransactionActions";
import { getBuyerTransactionsAction } from "../../../actions/BuyerTransactionActions";
import { getSubscriptionCounterAction } from "../../../actions/SubscriptionReportAction";
import {
  getContactsActions,
  buyerAgentsAction,
} from "./../../../actions/UserActions";
import UrlConstants from "../../../config/UrlConstants";
import downIcon from "./../../../assets/img/down.png";
import noRecord from "./../../../assets/img/no-record.png";
import Logo from "./../../../assets/img/logo.png";
import placeholderImage from "./../../../assets/img/property-placeholder.jpg";
import loaderImage from "./../../../assets/img/Ring-Preloader.gif";
import upIcon from "./../../../assets/img/up.png";
import {
  cryptoTokenDecode,
  getContingencyAssignee,
  getContingencyData,
  getTimeFromMins,
  toastMessage,
} from "./../../Common/Common";
import DeletePrompt from "./../../Common/DeletePrompt";
import * as code from "./../../../config/Constants";
import * as constant from "./../../../config/Constants";
import * as message from "./../../../config/CommonMessages";
import TransactionPrompt from "../../Common/TransactionPrompt";
import SystemBanner from "../../Common/SystemBanner";
import { TextField, InputAdornment } from "@material-ui/core";
import ReactPaginate from "react-paginate";
import { DebounceInput } from "react-debounce-input";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { REACT_APP_CRYPTO_SECRET_KEY } from "../../../config/Constants";
import DatePicker from "react-datepicker";
var CryptoJS = require("crypto-js");
var _ = require("lodash");

function Preloader(props) {
  return <img src={loaderImage} />;
}

class TransactionList extends React.Component {
  constructor(props) {
    var userType = cryptoTokenDecode().usertype;
    let currentType = cryptoTokenDecode().roleName;
    super(props);
    this.state = {
      transactions: [],
      originalTransactions: [],
      filteredTransactions: [],
      searchedTransactions: [],
      isFiltered: false,
      isSearched: false,
      showLoader: false,
      sortParams: { value: "modifiedDate", seq: "desc" },
      sortVariable: "modifiedDate",
      searchArtist: "",
      searchClient: "",
      searchDescription: "",
      searchShortname: "",
      onDelete: false,
      userType: userType.toUpperCase(),
      currentRole: !!currentType ? currentType.toUpperCase() : "",
      filterParam: "",
      delTransactionId: "",
      deleteTransactionPrompt: false,
      showHideFilter: false,
      showHideSearch: false,
      draftChecked: true,
      inProgressChecked: true,
      pauseChecked: true,
      completedChecked: false,
      canceledChecked: false,
      selectedFilterStatus: ["DRAFT", "INPROGRESS", "PAUSED"],
      showTransactionPrompt: false,
      showSystemBanners: true,
      clients: [],
      contacts: [],
      acctowners: [],
      acctownerId: "",
      page: 0,
      recordPerPage: constant.RECORD_PER_PAGE,
      pageCount: 0,
      inprogressState: "INPROGRESS",
      completeState: "",
      cancleState: "",
      filterTextByArtist: "",
      filterTextByClient: "",
      filterTextByArtwork: "",
      filterTextByArtworkId: "",
      filterByFromDate: null,
      filterByToDate: null,
      AscendingDesendingState: -1,
      PageSize: 8,
      permissionarray: [],
      callfromflag: "",
      id: new URLSearchParams(this.props.location.search).get("id"),
      transactionType: [],
    };
    this.deleteTransaction = this.deleteTransaction.bind(this);
  }

  getAcctowners(pageIndex) {
    let rolename = "admin";
    let myId = localStorage.getItem("ID");
    // this.props
    //   .buyerAgentsAction(this.state.recordPerPage, pageIndex)
    //   .then((aoRes) => {
    //     for (let a = 0; a < this.props.buyerAgents.length; a++) {
    //       rolename = "ep";
    //       this.props
    //         .getContactsActions(
    //           rolename,
    //           "?id=" + this.props.buyerAgents[a]._id + "&rolename=" + rolename
    //         )
    //         .then((res) => {
    //           for (let c = 0; c < this.props.contacts.length; c++) {
    //             if (this.props.contacts[c]._id === myId) {
    //               let acctowners = this.props.buyerAgents[a];
    //               localStorage.setItem("ownerId", acctowners._id);
    //               localStorage.setItem(
    //                 "companyName",
    //                 acctowners.companyInformation.name
    //               );
    //             }
    //           }
    //         });
    //     }
    //   });
  }

  componentWillMount() {
    this.setState({
      showLoader: true,
    });
    this.props.getTransactionTypeAction().then((res) => {
      this.setState({ transactionType: this.props.transactionType });
    });
    // if (this.state.userType === message.VENDOR && this.state.currentRole === message.BUYERAGENT) {
    //     console.log('calling getAcctowners');
    //     this.getAcctowners(this.state.page);
    // }
    // console.log("this.state.userType", this.state.userType);
    //transation list from redirection history object
    if (this.props.history.location.transactions != undefined) {
      this.setState(
        {
          transactions: this.props.history.location.transactions || [],
          originalTransactions: this.props.history.location.transactions || [],
          filteredTransactions: this.props.history.location.transactions || [],
        },
        () => {
          this.sortTransactions("modifiedDate", "desc");
          this.setState({
            showLoader: false,
          });
          this.changeTransactionsFilter();
        }
      );
    } else {
      //Load transcation by user type
      if (
        this.state.userType !== null &&
        this.state.userType === message.BUYER
      ) {
        // console.log("Hello i am buyer")
        this.setState({
          showLoader: true,
        });
        this.props
          .getAllTransactionsActionWithPagination({
            page: this.state.page,
            inprogressState: this.state.inprogressState,
            completeState: this.state.completeState,
            cancleState: this.state.cancleState,
            sortVariable: this.state.sortVariable,
            filterTextByArtist: this.state.filterTextByArtist,
            filterTextByClient: this.state.filterTextByClient,
            filterTextByArtwork: this.state.filterTextByArtwork,
            filterTextByArtworkId: this.state.filterTextByArtworkId,
            filterByFromDate: this.state.filterByFromDate
              ? moment(this.state.filterByFromDate).format("YYYY-MM-DD")
              : this.state.filterByFromDate,
            filterByToDate: this.state.filterByToDate
              ? moment(this.state.filterByToDate).format("YYYY-MM-DD")
              : this.state.filterByToDate,
            AscendingDesendingState: this.state.AscendingDesendingState,
            userType: this.state.userType,
            id: this.state.id,
            PageSize: this.state.PageSize,
          })
          .then((res) => {
            // console.log("at 123",res.data.data)
            // console.log("at 123",res.status)
            this.setState({
              showLoader: false,
            });
            if (res.status == 200) {
              // console.log("at here")
              this.setState({
                transactions: res.data.data,
                originalTransactions: res.data.data,
                filteredTransactions: res.data.data,
                pageCount: res.data.total,
              });
            } else {
              this.setState({
                transactions: [],
                originalTransactions: [],
                filteredTransactions: [],
              });
            }
          });
      } else if (
        this.state.userType !== null &&
        this.state.userType === message.VENDOR
      ) {
        // console.log("Hello i am vendor")
        this.setState({
          showLoader: true,
        });
        this.props
          .getAllTransactionsActionWithPagination({
            page: this.state.page,
            inprogressState: this.state.inprogressState,
            completeState: this.state.completeState,
            cancleState: this.state.cancleState,
            sortVariable: this.state.sortVariable,
            filterTextByArtist: this.state.filterTextByArtist,
            filterTextByClient: this.state.filterTextByClient,
            filterTextByArtwork: this.state.filterTextByArtwork,
            filterTextByArtworkId: this.state.filterTextByArtworkId,
            filterByFromDate: this.state.filterByFromDate
              ? moment(this.state.filterByFromDate).format("YYYY-MM-DD")
              : this.state.filterByFromDate,
            filterByToDate: this.state.filterByToDate
              ? moment(this.state.filterByToDate).format("YYYY-MM-DD")
              : this.state.filterByToDate,
            AscendingDesendingState: this.state.AscendingDesendingState,
            userType: this.state.userType,
            id: this.state.id,
            PageSize: this.state.PageSize,
          })
          .then((res) => {
            // console.log("at 123",res.data.data)
            // console.log("at 123",res.status)
            this.setState({
              showLoader: false,
            });
            if (res.status == 200) {
              // console.log("at here")
              this.setState({
                transactions: res.data.data,
                originalTransactions: res.data.data,
                filteredTransactions: res.data.data,
                pageCount: res.data.total,
              });
            } else {
              this.setState({
                transactions: [],
                originalTransactions: [],
                filteredTransactions: [],
              });
            }
          });
        this.getAcctowners(this.state.page);
      } else if (
        this.state.userType !== null &&
        this.state.userType != message.BUYER &&
        this.state.userType != message.VENDOR
      ) {
        if (this.state.userType === message.ADMIN) {
          //Get transactions from localstorage
          // let transactions = JSON.parse(localStorage.getItem('transactions') || [])
          // const UrlQueryStrings = this.props.location.search;
          // const queryValues = this.queryString(UrlQueryStrings);

          // console.log("ooooooo",(new URLSearchParams(this.props.location.search)).get('id'))
          // console.log("this.state.id",this.state.id)

          let parseddata = JSON.parse(
            localStorage.getItem("transactions") || []
          );
          this.setState({
            id: parseddata.id,
            callfromflag: parseddata.callfromflg,
            showLoader: true,
          });
          // console.log("parseddata", parseddata);
          this.props
            .getAllTransactionsActionWithPagination({
              page: this.state.page,
              inprogressState: this.state.inprogressState,
              completeState: this.state.completeState,
              cancleState: this.state.cancleState,
              sortVariable: this.state.sortVariable,
              filterTextByArtist: this.state.filterTextByArtist,
              filterTextByClient: this.state.filterTextByClient,
              filterTextByArtwork: this.state.filterTextByArtwork,
              filterTextByArtworkId: this.state.filterTextByArtworkId,
              filterByFromDate: this.state.filterByFromDate
                ? moment(this.state.filterByFromDate).format("YYYY-MM-DD")
                : this.state.filterByFromDate,
              filterByToDate: this.state.filterByToDate
                ? moment(this.state.filterByToDate).format("YYYY-MM-DD")
                : this.state.filterByToDate,
              AscendingDesendingState: this.state.AscendingDesendingState,
              userType: this.state.userType,
              id: parseddata.id,
              PageSize: this.state.PageSize,
              callfromflag: parseddata.callfromflg,
            })
            .then((res) => {
              // console.log("at 123",res.data.data)
              // console.log("at 123",res.status)
              this.setState({
                showLoader: false,
              });
              if (res.status == 200) {
                // console.log("at here")
                this.setState({
                  transactions: res.data.data,
                  originalTransactions: res.data.data,
                  filteredTransactions: res.data.data,
                  pageCount: res.data.total,
                });
              } else {
                this.setState({
                  transactions: [],
                  originalTransactions: [],
                  filteredTransactions: [],
                });
              }
            });

          // this.setState({
          //     transactions,
          //     originalTransactions: transactions,
          //     filteredTransactions: transactions,
          // }, () => {
          //     this.sortTransactions('modifiedDate', 'desc');
          //     this.setState({
          //         showLoader: false
          //     });
          //     this.changeTransactionsFilter()
          // })
        } else {
          // Get all transactions
          // console.log("I am Account Owner")
          this.setState({
            showLoader: true,
          });
          this.props
            .getAllTransactionsActionWithPagination({
              page: this.state.page,
              inprogressState: this.state.inprogressState,
              completeState: this.state.completeState,
              cancleState: this.state.cancleState,
              sortVariable: this.state.sortVariable,
              filterTextByArtist: this.state.filterTextByArtist,
              filterTextByClient: this.state.filterTextByClient,
              filterTextByArtwork: this.state.filterTextByArtwork,
              filterTextByArtworkId: this.state.filterTextByArtworkId,
              filterByFromDate: this.state.filterByFromDate
                ? moment(this.state.filterByFromDate).format("YYYY-MM-DD")
                : this.state.filterByFromDate,
              filterByToDate: this.state.filterByToDate
                ? moment(this.state.filterByToDate).format("YYYY-MM-DD")
                : this.state.filterByToDate,
              AscendingDesendingState: this.state.AscendingDesendingState,
              userType: this.state.userType,
              id: this.state.id,
              PageSize: this.state.PageSize,
            })
            .then((res) => {
              // console.log("at 123",res.data.data)
              // console.log("at 123",res.status)
              this.setState({
                showLoader: false,
              });
              if (res.status == 200) {
                // console.log("at here")
                this.setState({
                  transactions: res.data.data,
                  originalTransactions: res.data.data,
                  filteredTransactions: res.data.data,
                  pageCount: res.data.total,
                });
              } else {
                this.setState({
                  transactions: [],
                  originalTransactions: [],
                  filteredTransactions: [],
                });
              }
            });
        }
      }
    }

    // this.getAllContacts();

    let permission = localStorage.getItem("otherInfo");
    let permissionarray;
    if (permission) {
      let bytes = CryptoJS.AES.decrypt(permission, REACT_APP_CRYPTO_SECRET_KEY);
      let decryptedData = bytes.toString(CryptoJS.enc.Utf8);
      // console.log("decryptedData39", decryptedData);
      permissionarray = decryptedData.split(",");
      // console.log("permissionarray", permissionarray);

      this.setState({ permissionarray: permissionarray });
    }
  }

  searchByFromDate = (e) => {
    this.setState({
      filterByFromDate: e,
    });
  };

  searchByToDate = (e) => {
    this.setState({
      filterByToDate: e,
    });
  };

  searchByArtist(e) {
    let query = e.target.value;
    let transactions = this.state.transactions;

    if (query !== "") {
      let results = transactions.filter((transaction) => {
        return (
          transaction.listingAgents[0].firstname
            .toLowerCase()
            .includes(query.toLowerCase()) ||
          transaction.listingAgents[0].lastname
            .toLowerCase()
            .includes(query.toLowerCase())
        );
      });

      this.setState({
        transactions: results,
      });
    } else {
      this.getTransactions();
    }

    this.setState({
      searchArtist: query,
    });
  }

  searchByArtistwithpaginationApi = (e) => {
    // console.log("searchByArtistwithpaginationApi",e)
    this.setState({
      filterTextByArtist: e,
    });
  };

  searchByClient(e) {
    let query = e.target.value;
    let transactions = this.state.transactions;

    if (query !== "") {
      let results = transactions.filter((transaction) => {
        return (
          transaction.dsd.buyer[0].firstname
            .toLowerCase()
            .includes(query.toLowerCase()) ||
          transaction.dsd.buyer[0].lastname
            .toLowerCase()
            .includes(query.toLowerCase())
        );
      });

      this.setState({
        transactions: results,
      });
    } else {
      this.getTransactions();
    }

    this.setState({
      searchClient: query,
    });
  }

  searchByClientWithpaginationApi = (e) => {
    // console.log("searchByClientWithpaginationApi",e)
    this.setState({
      filterTextByClient: e,
    });
  };

  searchByDescription(e) {
    let query = e.target.value;
    let transactions = this.state.transactions;

    if (query !== "") {
      let results = transactions.filter((transaction) => {
        return transaction.dsd.heldBy
          .toLowerCase()
          .includes(query.toLowerCase());
      });

      this.setState({
        transactions: results,
      });
    } else {
      this.getTransactions();
    }

    this.setState({
      searchDescription: query,
    });
  }
  searchByDescriptionWithPaginationApi = (e) => {
    // console.log("searchByDescriptionWithPaginationApi",e)
    this.setState({
      filterTextByArtwork: e,
    });
  };
  searchByShortname(e) {
    let query = e.target.value;
    let transactions = this.state.transactions;

    if (query !== "") {
      let results = transactions.filter((transaction) => {
        return transaction.shortName
          .toLowerCase()
          .includes(query.toLowerCase());
      });

      this.setState({
        transactions: results,
      });
    } else {
      this.getTransactions();
    }

    this.setState({
      searchShortname: query,
    });
  }
  searchByShortnameWithPaginationApi = (e) => {
    //console.log("searchByShortnameWithPaginationApi", e);
    this.setState({ filterTextByArtworkId: e });
  };

  filterByStatus(e) {
    // console.log("e value",e)
    // console.log("inprogress state", this.state.inProgressChecked)
    // console.log("complete  state",this.state.completedChecked)
    // console.log("cancel state",this.state.canceledChecked)
    if (e == "INPROGRESS") {
      if (this.state.inProgressChecked == true) {
        this.setState({ inProgressChecked: !this.state.inProgressChecked });
        this.setState({ inprogressState: "" });
      } else {
        this.setState({ inProgressChecked: !this.state.inProgressChecked });
        this.setState({ inprogressState: "INPROGRESS" });
      }
    } else if (e == "COMPLETED") {
      if (this.state.completedChecked == true) {
        this.setState({ completedChecked: !this.state.completedChecked });
        this.setState({ completeState: "" });
      } else {
        this.setState({ completedChecked: !this.state.completedChecked });
        this.setState({ completeState: "COMPLETED" });
      }
    } else {
      if (this.state.canceledChecked == true) {
        this.setState({ canceledChecked: !this.state.canceledChecked });
        this.setState({ cancleState: "" });
      } else {
        this.setState({ canceledChecked: !this.state.canceledChecked });
        this.setState({ cancleState: "CANCELED" });
      }
    }
  }
  /**
   * @desc transaction filter based on status
   */
  changeTransactionsFilter() {
    let param = this.state.selectedFilterStatus;
    var transactions = this.state.originalTransactions;
    if (this.state.isSearched) {
      transactions = this.state.searchedTransactions;
    }
    transactions = transactions.filter((transaction) => {
      const typeMatch =
        param.length > 0
          ? param.filter((e) => {
              return (transaction.status + "").toUpperCase() == e.toUpperCase();
            }).length > 0
          : false;
      return typeMatch;
    });
    this.setState({
      transactions,
      filteredTransactions: transactions,
      isFiltered: false,
      filterParam: param,
    });
  }

  /**
   * @desc sort transactions by given sequence asc/desc
   * @param {*} param
   * @param {*} sequence
   */
  sortTransactions(param, sequence) {
    var sortParams = { value: param, seq: sequence };
    var transactions = this.state.transactions;
    if (sequence == undefined || sequence == "" || sequence == "asc") {
      transactions = _.sortBy(transactions, param);
    } else {
      transactions = _.sortBy(transactions, param).reverse();
    }
    this.setState({
      transactions,
      filteredTransactions: transactions,
      sortParams,
    });
  }

  sortTransactionsWithPaginationApi(value) {
    // console.log("sortTransactionsWithPaginationApi",value)
    this.setState({ sortVariable: value });
  }
  sortTransactionsAscDesWithpaginationApi = (e) => {
    // console.log("sortTransactionsAscDesWithpaginationApi",e)
    this.setState({ AscendingDesendingState: e });
  };
  clearFilter() {
    this.setState(
      {
        transactions: this.state.originalTransactions,
        filteredTransactions: this.state.originalTransactions,
        isFiltered: false,
        isSearched: false,
        searchParam: "",
        filterParam: "",
        draftChecked: true,
        inProgressChecked: true,
        pauseChecked: true,
        completedChecked: false,
        canceledChecked: false,
        selectedFilterStatus: ["DRAFT", "INPROGRESS", "PAUSED"],
      },
      () => {
        this.sortTransactions("modifiedDate", "desc");
        this.changeTransactionsFilter();
      }
    );
  }

  clearSearchFilter() {
    this.setState(
      {
        filterTextByArtist: "",
        filterTextByClient: "",
        filterTextByArtwork: "",
        filterTextByArtworkId: "",
        filterByFromDate: null,
        filterByToDate: null,
        page: 0,
        //showHideSearch: !this.state.showHideSearch,
      },
      () => {
        this.getTransactionPaginate();
      }
    );
  }

  /**
   * @desc get all transaction list and set to state
   */
  getTransactions() {
    if (this.state.userType !== null && this.state.userType === message.BUYER) {
      this.props.getBuyerTransactionsAction().then((res) => {
        this.setState(
          {
            transactions: this.props.buyerTransactions.data || [],
            originalTransactions: this.props.buyerTransactions.data || [],
            filteredTransactions: this.props.buyerTransactions.data || [],
          },
          () => {
            this.sortTransactions("modifiedDate", "desc");
            this.setState({
              showLoader: false,
            });
            this.changeTransactionsFilter();
          }
        );
      });
    } else if (
      this.state.userType !== null &&
      this.state.userType === message.VENDOR
    ) {
      this.props.getVendorTransactionsAction().then((res) => {
        this.setState(
          {
            transactions: this.props.vendorTransactions.data || [],
            originalTransactions: this.props.vendorTransactions.data || [],
            filteredTransactions: this.props.vendorTransactions.data || [],
          },
          () => {
            this.sortTransactions("modifiedDate", "desc");
            this.setState({
              showLoader: false,
            });
            this.changeTransactionsFilter();
          }
        );
      });
    } else {
      this.props.getAllTransactionsAction().then((res) => {
        this.setState(
          {
            transactions: this.props.transactions.data || [],
            originalTransactions: this.props.transactions.data || [],
            filteredTransactions: this.props.transactions.data || [],
          },
          () => {
            this.sortTransactions("modifiedDate", "desc");
            this.changeTransactionsFilter();
          }
        );
      });
    }
  }

  getTransactionPaginate = () => {
    this.setState({
      showLoader: true,
    });
    this.props
      .getAllTransactionsActionWithPagination({
        page: this.state.page,
        inprogressState: this.state.inprogressState,
        completeState: this.state.completeState,
        cancleState: this.state.cancleState,
        sortVariable: this.state.sortVariable,
        filterTextByArtist: this.state.filterTextByArtist,
        filterTextByClient: this.state.filterTextByClient,
        filterTextByArtwork: this.state.filterTextByArtwork,
        filterTextByArtworkId: this.state.filterTextByArtworkId,
        filterByFromDate: this.state.filterByFromDate
          ? moment(this.state.filterByFromDate).format("YYYY-MM-DD")
          : this.state.filterByFromDate,
        filterByToDate: this.state.filterByToDate
          ? moment(this.state.filterByToDate).format("YYYY-MM-DD")
          : this.state.filterByToDate,
        AscendingDesendingState: this.state.AscendingDesendingState,
        userType: this.state.userType,
        id: this.state.id,
        PageSize: this.state.PageSize,
        callfromflag: this.state.callfromflag,
      })
      .then((res) => {
        // console.log("at 123",res.data.data)
        // console.log("at 123",res.status)
        this.setState({
          showLoader: false,
        });
        if (res.status == 200) {
          // console.log("at here")
          this.setState({
            transactions: res.data.data,
            originalTransactions: res.data.data,
            filteredTransactions: res.data.data,
            pageCount: res.data.total,
          });
        } else {
          this.setState({
            transactions: [],
            originalTransactions: [],
            filteredTransactions: [],
          });
        }
      });
  };

  componentDidUpdate(prevProps, prevState) {
    // if (
    //   prevState.page !== this.state.page &&
    //   prevState.PageSize == this.state.PageSize
    // ) {
    //   // console.log("prevState.PageSize",prevState.PageSize)
    //   // console.log("this.state.PageSize",this.state.PageSize)
    //   this.getTransactionPaginate();
    // }
    if (prevState.inprogressState !== this.state.inprogressState) {
      this.getTransactionPaginate();
    }
    if (prevState.completeState !== this.state.completeState) {
      this.getTransactionPaginate();
    }
    if (prevState.cancleState !== this.state.cancleState) {
      this.getTransactionPaginate();
    }
    if (prevState.sortVariable !== this.state.sortVariable) {
      this.getTransactionPaginate();
    }
    // if (prevState.filterTextByArtist !== this.state.filterTextByArtist) {
    //   this.getTransactionPaginate();
    // }
    // if (prevState.filterTextByClient !== this.state.filterTextByClient) {
    //   this.getTransactionPaginate();
    // }
    // if (prevState.filterTextByArtwork !== this.state.filterTextByArtwork) {
    //   this.getTransactionPaginate();
    // }
    // if (prevState.filterTextByArtworkId !== this.state.filterTextByArtworkId) {
    //   this.getTransactionPaginate();
    // }
    // if (prevState.filterByFromDate !== this.state.filterByFromDate) {
    //   this.getTransactionPaginate();
    // }
    // if (prevState.filterByToDate !== this.state.filterByToDate) {
    //   this.getTransactionPaginate();
    // }
    if (
      prevState.AscendingDesendingState !== this.state.AscendingDesendingState
    ) {
      this.getTransactionPaginate();
    }
    if (prevState.PageSize !== this.state.PageSize) {
      this.getTransactionPaginate();
    }
    if (prevState.onDelete !== this.state.onDelete) {
      this.getTransactionPaginate();
    }
  }
  handlePageClick = (event) => {
    this.setState({ page: event.selected }, () => {
      this.getTransactionPaginate();
    });
  };

  confirmDeleteTransaction(id) {
    this.setState({ deleteTransactionPrompt: true, delTransactionId: id });
  }

  handleTransactionPrompt() {
    if (this.state.transactions.length <= 0) {
      this.props.history.push({
        pathname: "/artwork/create",
      });
    } else {
      this.setState({ showTransactionPrompt: true });
    }
  }

  handleChange = (e) => {
    // console.log("e",e.target.value)
    this.setState({ PageSize: e.target.value, page: 0 });
  };

  deleteTransaction(id) {
    this.props.deleteTransactionDataAction(id).then((res) => {
      // this.getTransactions();
      this.setState({
        deleteTransactionPrompt: false,
        delTransactionId: "",
        onDelete: !this.state.onDelete,
      });
      // if (
      //   this.state.userType === message.ACCTOWNER &&
      //   localStorage.getItem(code.IS_STRIPE_ENABLED) === "true"
      // ) {
      //   this.props.getSubscriptionCounterAction().then((counterRes) => {
      //     localStorage.setItem(
      //       "transactionCount",
      //       counterRes[0].transactionLimitCounter
      //     );
      //   });
      // }
      // if (
      //   this.state.userType === message.VENDOR &&
      //   this.state.currentRole === message.BUYERAGENT &&
      //   localStorage.getItem(code.IS_STRIPE_ENABLED) === "true"
      // ) {
      //   this.props.getSubscriptionCounterAction().then((counterRes) => {
      //     localStorage.setItem(
      //       "transactionCount",
      //       counterRes[0].transactionLimitCounter
      //     );
      //   });
      // }
    });
  }

  /**
   * @desc Progress bar data by transaction - task, status
   * Calculate schedule, overdue and completed task count and get % of it based on input param status
   */
  getProgressBar(tasks, status, tranSts) {
    if (tasks !== undefined && tasks !== null && tasks.length > 0) {
      let totalCnt = tasks.length;
      let schCnt = 0;
      let overdurCnt = 0;
      let completedCnt = 0;

      tasks.forEach((e) => {
        e.eventEndDate = new Date(
          moment(e.eventEndDate).format("MM/DD/YYYY ") + getTimeFromMins(e.time)
        );
        if (e.status == "SCHEDULED") {
          if (tranSts === "INPROGRESS") {
            schCnt = schCnt + 1;
            if (moment(e.eventEndDate) < moment()) {
              overdurCnt = overdurCnt + 1;
            }
          }
        } else if (e.status == "COMPLETED") {
          completedCnt = completedCnt + 1;
        }
      });

      let completed = 0;
      let overdue = 0;
      //get percentag of tasks based on given status
      if (status == "completed") {
        completed = (completedCnt * 100) / totalCnt;
        return completed.toFixed(0);
      } else if (status == "overdue") {
        overdue = (overdurCnt * 100) / totalCnt;
        return overdue.toFixed(0);
      } else {
        return totalCnt;
      }
    } else {
      return 0;
    }
  }

  setStatusFilter() {
    this.setState({ showHideFilter: !this.state.showHideFilter });
  }

  setSearchFilter() {
    this.setState({ showHideSearch: !this.state.showHideSearch });
  }

  getAllContacts() {
    this.props.getContactsActions().then((res) => {
      this.setState({
        contacts: this.props.contacts || [],
      });
    });
  }

  render() {
    //console.log("this.state.transactions", this.state.transactions);
    return (
      <>
        {this.state.showLoader ? (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        ) : (
          <div>
            <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center trans-listing-head">
              <Col>
                <h4 className="title-med mt-0 pt-1">Artworks</h4>
              </Col>

              <Col className="col-auto" align="right">
                <Form inline className="justify-content-end">
                  <Row className="trans-listing-head-row">
                    <Col className="col-auto px-0 d-flex trans-listing-head-dropdown">
                      <FormControl
                        sx={{ m: 0, mr: 1, minWidth: 120 }}
                        size="small"
                      >
                        <InputLabel id="demo-select-small">Limit</InputLabel>
                        <Select
                          labelId="demo-select-small"
                          id="demo-select-small"
                          value={this.state.PageSize}
                          label="Page"
                          onChange={this.handleChange}
                        >
                          <MenuItem value={8}>8</MenuItem>
                          <MenuItem value={16}>16</MenuItem>
                        </Select>
                      </FormControl>
                      <Form.Group controlId="" className="mb-0 mr-2">
                        <div className="c-select">
                          <select
                            className="form-control form-control-sm form-control-head"
                            style={{ width: "175px" }}
                            value={this.state.sortVariable}
                            onChange={(e) => {
                              this.sortTransactionsWithPaginationApi(
                                e.target.value
                              );
                            }}
                          >
                            <option value="modifiedDate">
                              Sort: Last Updated
                            </option>
                            <option value="createdDate">
                              Sort: Date Created
                            </option>
                          </select>
                        </div>
                      </Form.Group>
                    </Col>
                    {/* <Col className="col-auto px-0 d-flex trans-listing-head-dropdown">
                      <Form.Group controlId="" className="mb-0 mr-3">
                        <InputGroup className="icon-wrapper">
                          <Form.Control
                            type="text"
                            className="form-control-head"
                            placeholder="Artist"
                            value={this.state.searchArtist}
                            onChange={(e) => {
                              this.searchByArtist(e);
                            }}
                          />
                          <span className="form-control-icn">
                            <Search />
                          </span>
                        </InputGroup>
                      </Form.Group>
                      <Form.Group controlId="" className="mb-0 mr-3">
                        <InputGroup className="icon-wrapper">
                          <Form.Control
                            type="text"
                            className="form-control-head"
                            placeholder="Client"
                            value={this.state.searchClient}
                            onChange={(e) => {
                              this.searchByClient(e);
                            }}
                          />
                          <span className="form-control-icn">
                            <Search />
                          </span>
                        </InputGroup>
                      </Form.Group>
                      <Form.Group controlId="" className="mb-0 mr-3">
                        <InputGroup className="icon-wrapper">
                          <Form.Control
                            type="text"
                            className="form-control-head"
                            placeholder="Artwork"
                            value={this.state.searchDescription}
                            onChange={(e) => {
                              this.searchByDescription(e);
                            }}
                          />
                          <span className="form-control-icn">
                            <Search />
                          </span>
                        </InputGroup>
                      </Form.Group>
                      <Form.Group controlId="" className="mb-0 mr-3">
                        <InputGroup className="icon-wrapper">
                          <Form.Control
                            type="text"
                            className="form-control-head"
                            placeholder="Artwork ID"
                            value={this.state.searchShortname}
                            onChange={(e) => {
                              this.searchByShortname(e);
                            }}
                          />
                          <span className="form-control-icn">
                            <Search />
                          </span>
                        </InputGroup>
                      </Form.Group>
                      <Form.Group controlId="" className="mb-0 mr-2">
                        <div className="c-select">
                          <select
                            className="form-control form-control-sm form-control-head"
                            style={{ width: "175px" }}
                            value={this.state.sortVariable}
                            onChange={(e) => {
                              this.sortTransactionsWithPaginationApi(
                                e.target.value
                              );
                            }}
                          >
                            <option value="modifiedDate">
                              Sort: Last Updated
                            </option>
                            <option value="createdDate">
                              Sort: Date Created
                            </option>
                          </select>
                        </div>
                      </Form.Group>
                    </Col> */}

                    <Col className="col-auto pl-0 d-flex trans-listing-head-button">
                      <div className="multi-permit">
                        <Button
                          variant="primary"
                          className="btn-blue btn-head"
                          onClick={() => {
                            this.setStatusFilter();
                          }}
                          style={{
                            backgroundColor: "black",
                            border: "none",
                            marginTop: "1px",
                          }}
                        >
                          <Tune style={{ color: "white" }} />
                        </Button>
                        {this.state.showHideFilter && (
                          <ul style={{ listStyleType: "none", width: "200px" }}>
                            <li>
                              <input
                                type="checkbox"
                                value="INPROGRESS"
                                checked={this.state.inProgressChecked}
                                onChange={(e) => {
                                  this.filterByStatus("INPROGRESS");
                                }}
                              />
                              In Progress
                            </li>
                            <li>
                              <input
                                type="checkbox"
                                value="COMPLETED"
                                checked={this.state.completedChecked}
                                onChange={(e) => {
                                  this.filterByStatus("COMPLETED");
                                }}
                              />
                              Completed
                            </li>
                            <li>
                              <input
                                type="checkbox"
                                value="CANCELED"
                                checked={this.state.canceledChecked}
                                onChange={(e) => {
                                  this.filterByStatus("CANCELED");
                                }}
                              />
                              Canceled
                            </li>
                          </ul>
                        )}
                      </div>

                      <div className="multi-permit">
                        <Button
                          variant="primary"
                          className="btn-blue btn-head"
                          onClick={() => {
                            this.setSearchFilter();
                          }}
                          style={{
                            backgroundColor: "black",
                            border: "none",
                            marginTop: "1px",
                          }}
                        >
                          <Search style={{ color: "white" }} />
                        </Button>
                        {this.state.showHideSearch && (
                          <ul style={{ listStyleType: "none", width: "210px" }}>
                            <li>
                              <h6>
                                {" "}
                                <Search /> Artist Name
                              </h6>
                              <input
                                type="text"
                                minLength={0}
                                onChange={(e) =>
                                  this.searchByArtistwithpaginationApi(
                                    e.target.value
                                  )
                                }
                                placeholder="Artist Name"
                                value={this.state.filterTextByArtist}
                                autoComplete="off"
                              />
                            </li>
                            <li>
                              <h6>
                                {" "}
                                <Search /> Client Name
                              </h6>
                              <input
                                type="text"
                                minLength={0}
                                onChange={(e) =>
                                  this.searchByClientWithpaginationApi(
                                    e.target.value
                                  )
                                }
                                placeholder="Client Name"
                                value={this.state.filterTextByClient}
                                autoComplete="off"
                              />
                            </li>
                            <li>
                              <h6>
                                {" "}
                                <Search /> Artwork Type
                              </h6>
                              <select
                                style={{
                                  width: "100%",
                                  textTransform: "none",
                                  padding: "3px",
                                  // color: "#757575",
                                }}
                                onChange={(e) =>
                                  this.searchByDescriptionWithPaginationApi(
                                    e.target.value
                                  )
                                }
                                value={this.state.filterTextByArtwork}
                              >
                                <option value="">Select</option>
                                {this.state.transactionType &&
                                  this.state.transactionType.map((type) => {
                                    return (
                                      <option key={type._id} value={type.name}>
                                        {type.name}
                                      </option>
                                    );
                                  })}
                              </select>
                            </li>
                            <li>
                              <h6>
                                {" "}
                                <Search /> Artwork ID
                              </h6>
                              <input
                                type="text"
                                minLength={5}
                                placeholder="Artwork ID"
                                value={this.state.filterTextByArtworkId}
                                onChange={(e) => {
                                  console.log("here on change", e.target.value);
                                  this.searchByShortnameWithPaginationApi(
                                    e.target.value
                                  );
                                }}
                                autoComplete="off"
                              />
                            </li>
                            <li>
                              <h6>
                                {" "}
                                <Search /> From Date
                              </h6>
                              <DatePicker
                                onChange={(date) => {
                                  this.searchByFromDate(date);
                                }}
                                name="fromDate"
                                className="pl-1 date-picker"
                                dateFormat="MM-d-yyyy"
                                selected={this.state.filterByFromDate}
                                autoComplete="off"
                              />
                            </li>
                            <li>
                              <h6>
                                {" "}
                                <Search /> To Date
                              </h6>
                              <DatePicker
                                onChange={(date) => {
                                  this.searchByToDate(date);
                                }}
                                name="fromDate"
                                className="pl-1 date-picker"
                                dateFormat="MM-d-yyyy"
                                selected={this.state.filterByToDate}
                                autoComplete="off"
                              />
                            </li>
                            <li style={{ padding: "10px" }}>
                              <Button
                                variant="primary"
                                className="btn-blue btn-head"
                                onClick={() => {
                                  this.setState({ page: 0 }, () => {
                                    this.getTransactionPaginate();
                                  });
                                }}
                                style={{
                                  backgroundColor: "black",
                                  border: "none",
                                  marginRight: "15px",
                                }}
                              >
                                Search
                              </Button>
                              <Button
                                variant="primary"
                                className="btn-blue btn-head"
                                onClick={() => {
                                  this.clearSearchFilter();
                                }}
                                style={{
                                  backgroundColor: "black",
                                  border: "none",
                                }}
                              >
                                Clear All
                              </Button>
                            </li>
                          </ul>
                        )}
                      </div>

                      {this.state.currentRole !== message.BUYER &&
                      this.state.userType !== message.ADMIN ? (
                        <Form.Group controlId="" className="mb-0">
                          {this.state.currentRole === message.Artist &&
                          this.state.permissionarray.includes(
                            message.manage_transactions
                          ) ? (
                            <Button
                              variant="primary"
                              className="btn-blue btn-head mr-2 menu-btn"
                              onClick={() => {
                                // NEED TO LOOK AT THIS AGAIN LATER
                                // if (
                                //   localStorage.getItem(code.IS_STRIPE_ENABLED) ===
                                //   "true"
                                // ) {
                                //   // if (Number(localStorage.getItem("transactionCount")) >= Number(localStorage.getItem("transactionLimit"))) {
                                //   //     toastMessage(code.ERROR, "You have reached your maximum limit of transactions")
                                //   // }
                                //   if (
                                //     localStorage.getItem("isActive") === "false"
                                //   ) {
                                //     toastMessage(
                                //       code.ERROR,
                                //       message.SUBSCRIPTION_NOT_ACTIVE
                                //     );
                                //   } else {
                                //     // this.props.history.push("/transactions/create")
                                //     this.handleTransactionPrompt();
                                //   }
                                // } else {
                                //   // this.props.history.push("/transactions/create")
                                //   this.handleTransactionPrompt();
                                // }

                                this.handleTransactionPrompt();
                              }}
                            >
                              Create Artwork
                            </Button>
                          ) : this.state.userType === message.ACCTOWNER ? (
                            <Button
                              variant="primary"
                              className="btn-blue btn-head mr-2 menu-btn"
                              onClick={() => {
                                // NEED TO LOOK AT THIS AGAIN LATER
                                // if (
                                //   localStorage.getItem(code.IS_STRIPE_ENABLED) ===
                                //   "true"
                                // ) {
                                //   // if (Number(localStorage.getItem("transactionCount")) >= Number(localStorage.getItem("transactionLimit"))) {
                                //   //     toastMessage(code.ERROR, "You have reached your maximum limit of transactions")
                                //   // }
                                //   if (
                                //     localStorage.getItem("isActive") === "false"
                                //   ) {
                                //     toastMessage(
                                //       code.ERROR,
                                //       message.SUBSCRIPTION_NOT_ACTIVE
                                //     );
                                //   } else {
                                //     // this.props.history.push("/transactions/create")
                                //     this.handleTransactionPrompt();
                                //   }
                                // } else {
                                //   // this.props.history.push("/transactions/create")
                                //   this.handleTransactionPrompt();
                                // }

                                this.handleTransactionPrompt();
                              }}
                            >
                              Create Artwork
                            </Button>
                          ) : (
                            ""
                          )}
                        </Form.Group>
                      ) : (
                        ""
                      )}

                      {this.state.currentRole === message.Artist &&
                      this.state.permissionarray.includes(
                        message.manage_quick_appointment
                      ) ? (
                        <Form.Group>
                          <Button
                            variant="primary"
                            className="btn-blue btn-head menu-btn"
                            onClick={() => {
                              this.props.history.push({
                                pathname: "/quickAppointment",
                              });
                            }}
                          >
                            Quick Appointment
                          </Button>
                        </Form.Group>
                      ) : this.state.userType === message.ACCTOWNER ? (
                        <Form.Group>
                          <Button
                            variant="primary"
                            className="btn-blue btn-head menu-btn"
                            onClick={() => {
                              this.props.history.push({
                                pathname: "/quickAppointment",
                              });
                            }}
                          >
                            Quick Appointment
                          </Button>
                        </Form.Group>
                      ) : (
                        ""
                      )}
                    </Col>
                  </Row>
                </Form>
              </Col>
            </Row>
            <section className="transaction-list">
              <div className="container-custom">
                <Row className="align-items-center">
                  <Col className="text-right">
                    {this.state.AscendingDesendingState == -1 && (
                      <Button
                        className="btn-sort w-icn"
                        variant="transparent"
                        onClick={() => {
                          this.sortTransactionsAscDesWithpaginationApi(1);
                        }}
                      >
                        <img src={downIcon} alt="sort" />
                      </Button>
                    )}
                    {this.state.AscendingDesendingState == 1 && (
                      <Button
                        className="btn-sort w-icn"
                        variant="transparent"
                        onClick={() => {
                          this.sortTransactionsAscDesWithpaginationApi(-1);
                        }}
                      >
                        <img src={upIcon} alt="sort" />
                      </Button>
                    )}
                    {(this.state.isFiltered || this.state.isSearched) && (
                      <Button
                        className="btn-sort wt-icn"
                        variant="transparent"
                        onClick={() => {
                          this.clearFilter();
                        }}
                      >
                        <Cancel />
                        <span>Clear</span>
                      </Button>
                    )}
                  </Col>
                </Row>
                <Row>
                  {/* Transactions rendered in list */}
                  {this.state.transactions.map((tran) => {
                    return (
                      <Col xs="12" sm="3">
                        <Card className="transaction-single">
                          <Card.Header
                            className="p-0"
                            style={{ position: "relative" }}
                          >
                            <Carousel
                              className="slide-transaction"
                              interval={3000}
                              indicators={false}
                              fade={true}
                              controls={
                                tran.dsd.property.image.length <= 1
                                  ? false
                                  : true
                              }
                            >
                              {tran.dsd.property.image.map((img, i) => {
                                return (
                                  <Carousel.Item
                                    key={i}
                                    onClick={() => {
                                      // localStorage.setItem("currentRole", tran.CurrentRole);

                                      !tran.dsd.draft
                                        ? this.props.history.push({
                                            pathname:
                                              "/artwork/detail/" + tran._id,
                                            currentRole: tran.CurrentRole,
                                          })
                                        : this.props.history.push({
                                            pathname:
                                              "/artwork/schedule/" + tran._id,
                                            currentRole: tran.CurrentRole,
                                          });
                                    }}
                                  >
                                    {img == null || img == "" ? (
                                      <img
                                        className="d-block w-100"
                                        src={placeholderImage}
                                      />
                                    ) : (
                                      <ImageLoader
                                        src={
                                          UrlConstants.AdminCreateTransactionUrl +
                                          "/upload?id=" +
                                          tran._id +
                                          "&img=" +
                                          img
                                        }
                                      >
                                        <img />
                                        <img src={placeholderImage} />
                                        <Preloader />
                                      </ImageLoader>
                                    )}
                                  </Carousel.Item>
                                );
                              })}
                              {tran.dsd.property.image.length <= 0 && (
                                <Carousel.Item
                                  onClick={() => {
                                    // localStorage.setItem("currentRole", tran.CurrentRole);

                                    !tran.dsd.draft
                                      ? this.props.history.push({
                                          pathname:
                                            "/artwork/detail/" + tran._id,
                                          currentRole: tran.CurrentRole,
                                        })
                                      : this.props.history.push({
                                          pathname:
                                            "/artwork/schedule/" + tran._id,
                                          currentRole: tran.CurrentRole,
                                        });
                                  }}
                                >
                                  <img
                                    className="d-block w-100"
                                    src={placeholderImage}
                                  />
                                </Carousel.Item>
                              )}
                            </Carousel>
                          </Card.Header>
                          <Card.Body className="p-2">
                            <div
                              onClick={() => {
                                // localStorage.setItem("currentRole", tran.CurrentRole);

                                !tran.dsd.draft
                                  ? this.props.history.push({
                                      pathname: "/artwork/detail/" + tran._id,
                                      currentRole: tran.CurrentRole,
                                    })
                                  : this.props.history.push({
                                      pathname: "/artwork/schedule/" + tran._id,
                                      currentRole: tran.CurrentRole,
                                    });
                              }}
                            >
                              <Row>
                                <Col>
                                  {/* <Card.Title className="mb-0 font-16 font-500">
                                    {getContingencyAssignee(
                                      this.state.contacts,
                                      tran.contingencies,
                                      "Client",
                                      "fullname"
                                    )}
                                  </Card.Title> */}
                                  {tran &&
                                  tran.clientdata &&
                                  tran.clientdata[0] &&
                                  tran.clientdata[0].isDeleted &&
                                  tran.clientdata[0].isDeleted == true &&
                                  tran.status == "INPROGRESS" ? (
                                    <Card.Title className="text-danger mb-0 font-16 font-500">
                                      {tran.dsd.buyer[0].firstname +
                                        " " +
                                        (tran.dsd.buyer[0].lastname
                                          ? tran.dsd.buyer[0].lastname
                                          : "")}
                                    </Card.Title>
                                  ) : (
                                    <Card.Title className=" text-success mb-0 font-16 font-500">
                                      {tran.dsd.buyer[0].firstname +
                                        " " +
                                        (tran.dsd.buyer[0].lastname
                                          ? tran.dsd.buyer[0].lastname
                                          : "")}
                                    </Card.Title>
                                  )}

                                  <Card.Text className="mb-2 font-14 font-400">
                                    {(tran.transactionType
                                      ? tran.transactionType
                                      : "") +
                                      (tran.dsd.heldBy
                                        ? " - " + tran.dsd.heldBy
                                        : "")}
                                  </Card.Text>
                                  {/* <Card.Text className="mb-2 font-14 font-400">{(tran.heldBy ? tran.heldBy : "")}</Card.Text> */}
                                </Col>
                              </Row>
                              <Row>
                                <Col>
                                  {this.state.userType === message.ACCTOWNER ||
                                  this.state.userType === message.BUYER ? (
                                    <div style={{ lineHeight: "1.1em" }}>
                                      <span className="color-grey-2 font-12 font-500">
                                        Artist:{" "}
                                      </span>
                                      {/* <span className="color-light-blue-1 font-12 font-600">{getContingencyAssignee(this.state.contacts, tran.contingencies, "Artist", "fullname")}</span> */}
                                      {tran &&
                                      tran.Artist &&
                                      tran.Artist.isDeleted &&
                                      tran.Artist.isDeleted == true &&
                                      tran.status == "INPROGRESS" ? (
                                        <span className="text-danger font-12 font-600">
                                          {tran.dsd.listingAgents[0].firstname +
                                            " " +
                                            tran.dsd.listingAgents[0].lastname}
                                        </span>
                                      ) : (
                                        <span className="color-light-blue-1 font-12 font-600">
                                          {tran.dsd.listingAgents[0].firstname +
                                            " " +
                                            tran.dsd.listingAgents[0].lastname}
                                        </span>
                                      )}
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                  {/* <div style={{ lineHeight: "1.1em" }}>
                                                                    <span className="color-grey-2 font-12 font-500">Artist: </span>
                                                                    <span className="color-light-blue-1 font-12 font-600">{getContingencyAssignee(this.state.contacts, tran.contingencies, "Artist")}</span>
                                                                </div> */}
                                  <div style={{ lineHeight: "1.1em" }}>
                                    <span className="color-grey-2 font-12 font-500">
                                      Artwork ID:{" "}
                                    </span>
                                    <span className="color-light-blue-1 font-12 font-600">
                                      {tran.shortName}
                                    </span>
                                  </div>
                                  <div style={{ lineHeight: "1.1em" }}>
                                    <span className="color-grey-2 font-12 font-500">
                                      Status:{" "}
                                    </span>
                                    <span className="color-light-blue-1 font-12 font-600">
                                      {tran.status}
                                    </span>
                                  </div>
                                  <div style={{ lineHeight: "1.1em" }}>
                                    <span className="color-grey-2 font-12 font-500">
                                      Updated on:{" "}
                                    </span>
                                    <span className="color-grey-1 font-12 font-500">
                                      {moment(tran.modifiedDate).format(
                                        "MM/DD/YYYY, hh:mm a"
                                      )}
                                    </span>
                                  </div>
                                  <div style={{ lineHeight: "1.1em" }}>
                                    <span className="color-grey-2 font-12 font-500">
                                      Created on:{" "}
                                    </span>
                                    <span className="color-grey-1 font-12 font-500">
                                      {moment(tran.createdDate).format(
                                        "MM/DD/YYYY, hh:mm a"
                                      )}
                                    </span>
                                  </div>
                                  {/* {(this.state.userType === message.VENDOR && this.state.currentRole === message.BUYERAGENT) ?
                                                                <div style={{ lineHeight: "1.1em" }}>
                                                                    <span className="color-grey-2 font-12 font-500">User Role: </span>
                                                                    <span className="color-grey-1 font-12 font-500">Artist</span>
                                                                </div> : ""} */}
                                  {/* {(tran.CurrentRole === message.ACCTOWNER && getContingencyData(tran.contingencies, "First Appointment", "assignee") === contactId) ?
                                                                <div style={{ lineHeight: "1.1em" }}>
                                                                    <span className="color-grey-2 font-12 font-500">User Role: </span>
                                                                    <span className="color-grey-1 font-12 font-500">Artist</span>
                                                                </div> : ""}
                                                                {(tran.CurrentRole === message.ACCTOWNER && getContingencyData(tran.contingencies, "Paperwork", "assignee") === contactId) ?
                                                                <div style={{ lineHeight: "1.1em" }}>
                                                                    <span className="color-grey-2 font-12 font-500">User Role: </span>
                                                                    <span className="color-grey-1 font-12 font-500">Client</span>
                                                                </div> : ""} */}
                                  {/* {(this.state.userType === message.BUYER) && tran.CurrentRole === message.BUYER ?
                                                                <div style={{ lineHeight: "1.1em" }}>
                                                                    <span className="color-grey-2 font-12 font-500">User Role: </span>
                                                                    <span className="color-grey-1 font-12 font-500">Client</span>
                                                                </div> : ""} */}
                                </Col>
                              </Row>
                            </div>

                            {(this.state.userType === message.VENDOR &&
                              !this.state.permissionarray.includes(
                                message.manage_transactions
                              )) ||
                            this.state.userType === message.BUYER ||
                            this.state.userType === message.ADMIN ? (
                              ""
                            ) : (
                              <Dropdown alignRight className="dropdown-action">
                                <Dropdown.Toggle
                                  variant="transparent"
                                  id="dropdown-folder1"
                                  className="p-0"
                                >
                                  <MoreVert />
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                  <Dropdown.Item
                                    onClick={() => {
                                      localStorage.setItem(
                                        "currentRole",
                                        tran.CurrentRole
                                      );
                                      !tran.dsd.draft
                                        ? this.props.history.push(
                                            "/artwork/detail/" + tran._id
                                          )
                                        : this.props.history.push(
                                            "/artwork/schedule/" + tran._id
                                          );
                                    }}
                                  >
                                    Edit
                                  </Dropdown.Item>
                                  {tran.status !== "COMPLETED" && (
                                    <Dropdown.Item
                                      onClick={() => {
                                        // if (
                                        //   localStorage.getItem("isActive") ===
                                        //   "false"
                                        // ) {
                                        //   toastMessage(
                                        //     code.ERROR,
                                        //     message.SUBSCRIPTION_NOT_ACTIVE
                                        //   );
                                        // } else {
                                        //   this.confirmDeleteTransaction(
                                        //     tran._id
                                        //   );
                                        // }

                                        this.confirmDeleteTransaction(tran._id);
                                      }}
                                    >
                                      Delete
                                    </Dropdown.Item>
                                  )}
                                </Dropdown.Menu>
                              </Dropdown>
                            )}
                          </Card.Body>
                        </Card>
                      </Col>
                    );
                  })}
                </Row>
              </div>
            </section>
            {this.state.transactions.length <= 0 && (
              <>
                {this.state.userType === message.VENDOR ||
                this.state.userType === message.BUYER ? (
                  <div className="no-transaction no-record">
                    <div className="no-transaction-inner">
                      <img src={noRecord} alt="no record" />
                      <p>No artworks found</p>
                    </div>
                  </div>
                ) : this.state.isFiltered || this.state.isSearched ? (
                  <div className="no-transaction no-record">
                    <div className="no-transaction-inner">
                      <img src={noRecord} alt="no record" />
                      <p>No artworks found</p>
                    </div>
                  </div>
                ) : (
                  <div className="no-transaction">
                    <div className="no-transaction-inner">
                      <img
                        src={Logo}
                        className="no-transaction-content"
                        alt=""
                      />
                      <h2 className="no-transaction-content">
                        No artworks found
                      </h2>
                      <hr />
                      {this.state.userType !== message.VENDOR &&
                      this.state.userType !== message.BUYER &&
                      this.state.userType !== message.ADMIN ? (
                        <Button
                          className="text-uppercase btn-orange btn-orange-lg menu-btn"
                          onClick={() => {
                            // if (
                            //   localStorage.getItem(code.IS_STRIPE_ENABLED) ===
                            //   "true"
                            // ) {
                            //   if (
                            //     Number(
                            //       localStorage.getItem("transactionCount")
                            //     ) >=
                            //     Number(localStorage.getItem("transactionLimit"))
                            //   ) {
                            //     toastMessage(
                            //       code.ERROR,
                            //       "You have reached your maximum limit of artworks"
                            //     );
                            //   } else if (
                            //     localStorage.getItem("isActive") === "false"
                            //   ) {
                            //     toastMessage(
                            //       code.ERROR,
                            //       message.SUBSCRIPTION_NOT_ACTIVE
                            //     );
                            //   } else {
                            //     // this.props.history.push("/transactions/create")
                            //     this.handleTransactionPrompt();
                            //   }
                            // } else {
                            //   // this.props.history.push("/transactions/create")
                            //   this.handleTransactionPrompt();
                            // }

                            this.handleTransactionPrompt();
                          }}
                        >
                          Create Artwork
                        </Button>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                )}
              </>
            )}
            {/* Delete Transaction Modal */}
            <DeletePrompt
              deletePrompt={this.state.deleteTransactionPrompt}
              itemId={this.state.delTransactionId}
              cancel={() => {
                this.setState({ deleteTransactionPrompt: false });
              }}
              deleteConfirm={this.deleteTransaction}
            />
            {/* Transaction Choice Modal */}
            <TransactionPrompt
              showTransactionPrompt={this.state.showTransactionPrompt}
              cancel={() => {
                this.setState({ showTransactionPrompt: false });
              }}
            />
            {/*show system banners */}
            <SystemBanner
              showSystemBanners={this.state.showSystemBanners}
              cancel={() => {
                this.setState({ showSystemBanners: false });
              }}
            />
          </div>
        )}
        {this.state.transactions.length > 0 && (
          <div>
            <ReactPaginate
              previousLabel={"previous"}
              nextLabel={"next"}
              breakLabel={"..."}
              pageCount={this.state.pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={3}
              onPageChange={this.handlePageClick}
              containerClassName={"pagination justify-content-center"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              breakClassName={"page-item"}
              breakLinkClassName={"page-link"}
              activeClassName={"active"}
              forcePage={this.state.page}
            />
          </div>
        )}
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    transactions: state.reducer.transactions,
    isDTransDeleted: state.reducer.isDTransDeleted,
    vendorTransactions: state.reducer.vendorTransactions,
    buyerTransactions: state.reducer.buyerTransactions,
    contacts: state.reducer.contacts,
    buyerAgents: state.reducer.buyerAgents,
    transactionType: state.reducer.transactionType,
  };
};

export default connect(mapStateToProps, {
  getAllTransactionsAction,
  deleteTransactionDataAction,
  getVendorTransactionsAction,
  getBuyerTransactionsAction,
  getSubscriptionCounterAction,
  getContactsActions,
  buyerAgentsAction,
  getAllTransactionsActionWithPagination,
  getTransactionTypeAction,
})(TransactionList);
